/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Offchart2Inputs */

const id_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di luar bagan`)
};

const ms_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di luar carta`)
};

const da_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uden for diagram`)
};

const de_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Außerhalb der Tabelle`)
};

const en_us2_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off chart`)
};

const es_es2_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuera del ranking`)
};

const es_mx2_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuera de la lista`)
};

const fil_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala sa chart`)
};

const fr_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hors classement`)
};

const it_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuori classifica`)
};

const hu_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs a listán`)
};

const nl_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buiten grafiek`)
};

const no_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utenfor listen`)
};

const pl_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poza wykresem`)
};

const pt_br2_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fora do gráfico`)
};

const pt_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fora do gráfico`)
};

const ro_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`În afara clasamentului`)
};

const fi_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pois listalta`)
};

const sv_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utanför listan`)
};

const vi_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngoài bảng xếp hạng`)
};

const tr_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste dışı`)
};

const cs_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mimo žebříček`)
};

const bg_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извън класацията`)
};

const ru_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вне чарта`)
};

const uk_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поза чартом`)
};

const ar_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خارج الرسم البياني`)
};

const hi_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चार्ट से बाहर`)
};

const th_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นอกแผนภูมิ`)
};

const ja_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャート圏外`)
};

const zh_cn2_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跌出榜单`)
};

const zh_hant1_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未上榜`)
};

const ko_components_performancetable_offchart2 = /** @type {(inputs: Components_Performancetable_Offchart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`차트 밖`)
};

/**
* | output |
* | --- |
* | "Off chart" |
*
* @param {Components_Performancetable_Offchart2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_offchart2 = /** @type {((inputs?: Components_Performancetable_Offchart2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Offchart2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_offchart2(inputs)
	if (locale === "ms") return ms_components_performancetable_offchart2(inputs)
	if (locale === "da") return da_components_performancetable_offchart2(inputs)
	if (locale === "de") return de_components_performancetable_offchart2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_offchart2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_offchart2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_offchart2(inputs)
	if (locale === "fil") return fil_components_performancetable_offchart2(inputs)
	if (locale === "fr") return fr_components_performancetable_offchart2(inputs)
	if (locale === "it") return it_components_performancetable_offchart2(inputs)
	if (locale === "hu") return hu_components_performancetable_offchart2(inputs)
	if (locale === "nl") return nl_components_performancetable_offchart2(inputs)
	if (locale === "no") return no_components_performancetable_offchart2(inputs)
	if (locale === "pl") return pl_components_performancetable_offchart2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_offchart2(inputs)
	if (locale === "pt") return pt_components_performancetable_offchart2(inputs)
	if (locale === "ro") return ro_components_performancetable_offchart2(inputs)
	if (locale === "fi") return fi_components_performancetable_offchart2(inputs)
	if (locale === "sv") return sv_components_performancetable_offchart2(inputs)
	if (locale === "vi") return vi_components_performancetable_offchart2(inputs)
	if (locale === "tr") return tr_components_performancetable_offchart2(inputs)
	if (locale === "cs") return cs_components_performancetable_offchart2(inputs)
	if (locale === "bg") return bg_components_performancetable_offchart2(inputs)
	if (locale === "ru") return ru_components_performancetable_offchart2(inputs)
	if (locale === "uk") return uk_components_performancetable_offchart2(inputs)
	if (locale === "ar") return ar_components_performancetable_offchart2(inputs)
	if (locale === "hi") return hi_components_performancetable_offchart2(inputs)
	if (locale === "th") return th_components_performancetable_offchart2(inputs)
	if (locale === "ja") return ja_components_performancetable_offchart2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_offchart2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_offchart2(inputs)
	return ko_components_performancetable_offchart2(inputs)
});
export { components_performancetable_offchart2 as "components.performanceTable.offChart" }